import { FC, useState, useRef, useCallback } from 'react';
import { Assert } from '@team/assert';
import { ReactHooks } from '@team/react-hooks';
import { ContextValue, SlideRefsMap, Context } from './services/context';
import { FALLBACK_CURRENT_SLIDE_INDEX, FALLBACK_SLIDE_COUNT } from './const';

export const Entry: FC<WithChildren> = ({ children }) => {
  const [slideCount, setSlideCount] = useState(FALLBACK_SLIDE_COUNT);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(
    FALLBACK_CURRENT_SLIDE_INDEX
  );

  const scrollerRef = useRef<HTMLDivElement>(null);

  const slideRefsMap = useRef<SlideRefsMap>(new Map());
  const createSlideRef = (slideIndex: number) => (element: HTMLDivElement) => {
    slideRefsMap.current.set(slideIndex, element);
  };

  const scrollTo = useCallback((targetOrSlideIndex: Element | number) => {
    if (Assert.isNodeInstance(targetOrSlideIndex)) {
      const target = targetOrSlideIndex;

      target.scrollIntoView();

      return;
    }

    const slideIndex = targetOrSlideIndex;
    const target = slideRefsMap.current.get(slideIndex);

    if (Assert.isUndefined(target)) {
      return;
    }

    target.scrollIntoView();
  }, []);

  const contextValue = ReactHooks.useObjectMemo<ContextValue>({
    slideCount,
    setSlideCount,
    currentSlideIndex,
    setCurrentSlideIndex,
    scrollerRef,
    slideRefsMap,
    createSlideRef,
    scrollTo,
  });

  return <Context.Provider value={contextValue}>{children}</Context.Provider>;
};
